<script lang="ts" setup>
import { generateId } from '#helpers';
import { computed, type PropType } from 'vue';

const props = defineProps({
  label: { type: String, required: false, default: '' },
  subLabel: { type: String, default: '' },
  checked: { type: Boolean, required: true },
  disabled: { type: Boolean, required: false, default: false },
  value: { type: String, required: true },
  name: { type: String, required: true },
  size: { type: String as PropType<'small' | 'normal'>, required: false, default: 'normal' },
  testId: { type: String, required: false, default: '' }
});

const uuid = generateId('radio-');

const emit = defineEmits<{
  check: [name: string];
}>();

const labelClx = computed(() => ({
  'border-primary': props.checked
}));

const sizeClx = computed(() => ({
  'justify-center !py-2 !mb-0': props.size === 'small'
}));

const disabledClx = computed(() => ({
  'opacity-50': props.disabled,
  'hover:cursor-default': props.disabled
}));

function onChange(event: string) {
  if (!event) {
    return;
  }
  emit('check', event);
}
</script>

<template>
  <label
    class="flex flex-row items-center p-4 mb-4 border rounded hover:cursor-pointer"
    :for="uuid"
    :class="[labelClx, sizeClx, disabledClx]"
    :data-testid="testId"
  >
    <input
      :id="uuid"
      type="radio"
      :checked="checked"
      :disabled="props.disabled"
      :value="value"
      :name="name"
      class="mr-2"
      @change="onChange(($event.target as HTMLInputElement).value)"
    />
    <span class="flex flex-col">
      <span class="text-base font-bold">{{ label }}</span>
      <span v-if="subLabel" class="text-gray-500 block text-sm">{{ subLabel }}</span>
    </span>
  </label>
</template>
